var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-navbar",
    [
      _c(
        "template",
        { slot: "start" },
        [
          _c(
            "b-navbar-item",
            {
              attrs: { tag: "div" },
              on: {
                click: function ($event) {
                  return _vm.$store.dispatch("switchSideBar")
                },
              },
            },
            [
              _c("b-icon", {
                attrs: { icon: "bars", type: "is-info", size: "is-small" },
              }),
            ],
            1
          ),
          _vm.user && _vm.user.group && _vm.user.group.plants
            ? _c(
                "b-navbar-item",
                { attrs: { tag: "div" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: { icon: "industry", expanded: "" },
                      model: {
                        value: _vm.selectedPlant,
                        callback: function ($$v) {
                          _vm.selectedPlant = $$v
                        },
                        expression: "selectedPlant",
                      },
                    },
                    _vm._l(_vm.user.group.plants, function (plant) {
                      return _c(
                        "option",
                        { key: plant.id, domProps: { value: plant.id } },
                        [_vm._v(" " + _vm._s(plant.name) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "template",
        { slot: "end" },
        [
          _c(
            "b-navbar-dropdown",
            { attrs: { hoverable: "" } },
            [
              _c(
                "template",
                { slot: "label" },
                [
                  _c("b-icon", {
                    attrs: {
                      icon: "user-circle",
                      type: "is-link",
                      size: "is-small",
                    },
                  }),
                  _c("span", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.user ? _vm.user.displayName : "No user") +
                        " "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-navbar-item",
                { attrs: { tag: "router-link", to: { name: "profile" } } },
                [
                  _c("b-icon", {
                    attrs: { icon: "id-card", pack: "far", size: "is-small" },
                  }),
                  _c("span", [_vm._v(" Profile ")]),
                ],
                1
              ),
              _c(
                "b-navbar-item",
                { attrs: { tag: "router-link", to: { name: "settings" } } },
                [
                  _c("b-icon", { attrs: { icon: "cog", size: "is-small" } }),
                  _c("span", [_vm._v(" Settings ")]),
                ],
                1
              ),
            ],
            2
          ),
          _c("language-switcher"),
          _c(
            "b-navbar-item",
            {
              on: {
                click: function ($event) {
                  return _vm.handleLogout()
                },
              },
            },
            [
              _c("b-icon", {
                attrs: {
                  icon: "power-off",
                  size: "is-small",
                  type: "is-danger",
                },
              }),
              _c("span", [_vm._v(" " + _vm._s(_vm.$t(`navbar.logout`)) + " ")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }